var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-0 elevation-0"},[_c('v-card-title',{staticClass:"coolgray--text body-2 font-weight-medium py-0"},[_vm._v(" "+_vm._s(_vm.featureItem.name)+" ")])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }